import React, { lazy } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-cream py-10 px-4" data-id="element-269">
      <div className="max-w-[600px] mx-auto text-center" data-id="element-270">
        <div className="flex justify-center mb-6" data-id="element-271">
          <img loading="lazy" src="https://cdn.magicpatterns.com/uploads/8UZmKRPbuj1no3sjHF34ed/garantia_7_dias.png" alt="Garantía de 7 Días" className="w-48 h-auto drop-shadow-2xl" width="192" height="192" data-id="element-272" />
        </div>

        <h2 className="text-[26px] font-bold text-brand-black mb-6 leading-[1.2] flex items-center justify-center gap-2" data-id="element-273">
          GARANTÍA TOTAL
        </h2>

        <div className="bg-brand-black-light border border-white/10 rounded-xl p-8 shadow-medium relative overflow-hidden" data-id="element-274">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary to-primary-dark" data-id="element-275"></div>

          <p className="text-lg text-dark-gray leading-relaxed mb-4" data-id="element-276">
            Si este no es el sistema más claro y práctico que has visto para
            entender comandos eléctricos…
          </p>
          <p className="text-xl font-bold text-brand-black mb-4" data-id="element-277">
            Te devolvemos el 100% de tu dinero.
          </p>
          <p className="text-primary font-bold text-lg" data-id="element-278">Sin preguntas.</p>
        </div>
      </div>
    </section>;
}